module.exports = __webpack_public_path__ + "static/media/corporate-services-img15.8d457ef4.jpg";